const ariaExpanded = (toggleButton, content) => {
    if (!toggleButton || !content) return;

    toggleButton.addEventListener('click', function () {
        const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

        toggleButton.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);

        content.classList.toggle('visible', !isExpanded);
    });
}

const ariaLabelledby = (toggleButton, content) => {
    if (!toggleButton || !content) return;

    if (!toggleButton.id) {
        toggleButton.id = `accordion-toggle-${Math.random().toString(36).substr(2, 9)}`;
    }

    content.setAttribute('aria-labelledby', toggleButton.id);
}

const enableTabNavigation = (accordions) => {
    accordions.forEach((toggleButton, index) => {
        const button = toggleButton.querySelector(".accordion__dropdown-toggle");
        const content = toggleButton.querySelector(".accordion__dropdown-content");

        // Ensure the button is focusable by setting tabindex="0"
        if (button) {
            button.setAttribute('tabindex', '0');
        }

        button.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                // If it's not the last accordion, prevent default behavior and move to the next one
                if (index < accordions.length - 1) {
                    e.preventDefault();

                    // Find the next accordion toggle button
                    const nextIndex = (index + 1) % accordions.length;
                    const nextButton = accordions[nextIndex].querySelector(".accordion__dropdown-toggle");

                    // Move focus to the next accordion's toggle button
                    if (nextButton) {
                        nextButton.focus();
                    }
                }
            }

            if (e.key === 'Enter' && content) {
                // Close all other accordions first
                accordions.forEach((otherToggle) => {
                    const otherContent = otherToggle.querySelector(".accordion__dropdown-content");
                    if (otherContent && otherContent !== content) {
                        otherContent.style.height = "0";
                    }
                });


                if (content.style.height === "auto") {
                    content.style.height = "0";
                } else {
                    content.style.height = "auto";
                }
            }
        });
    });

    // Ensure normal tabbing behavior continues after the last accordion
    if(accordions) {
        const lastAccordion = accordions[accordions.length - 1];
        const lastButton = lastAccordion && lastAccordion.querySelector(".accordion__dropdown-toggle");

        if (lastButton) {
            lastButton.addEventListener('keydown', (e) => {
                if (e.key === 'Tab') {
                    // Allow normal tabbing behavior when leaving the last accordion
                    e.preventDefault();
                    lastButton.blur();
                }
            });
        }
    }
}

const applyAriaAttributes = (toggleSelector, contentSelector, labelledby = true) => {
    const elements = document.querySelectorAll(toggleSelector);

    elements.forEach((toggleElement) => {
        const content = toggleElement.querySelector(contentSelector);

        if (content) {
            if (labelledby) {
                ariaLabelledby(toggleElement, content);
            }
            ariaExpanded(toggleElement, content);
        }
    });
}

const toggleAriaSelected = (toggleSelector, contentSelector) => {
    const tabs = document.querySelectorAll(toggleSelector);

    tabs.forEach((tabButton) => {
        tabButton.setAttribute('role', 'tab');
        tabButton.setAttribute('aria-selected', 'false');
        tabButton.setAttribute('tabindex', '-1');

        tabButton.addEventListener('click', () => {
            // Deselect all tabs and hide their content
            tabs.forEach((otherTab) => {
                otherTab.setAttribute('aria-selected', 'false');
                otherTab.classList.remove('tabs__toggle--active');
                // Make non-active tabs focusable
                otherTab.setAttribute('tabindex', '-1');
                const otherContent = document.querySelector(otherTab.getAttribute('aria-controls'));
                if (otherContent) {
                    otherContent.setAttribute('aria-hidden', 'true');
                    otherContent.classList.remove('visible');
                }
            });

            tabButton.setAttribute('aria-selected', 'true');
            tabButton.classList.add('tabs__toggle--active');
            tabButton.removeAttribute('tabindex'); // Remove tabindex when active

            const content = document.querySelector(tabButton.getAttribute('aria-controls'));
            if (content) {
                content.setAttribute('aria-hidden', 'false');
                content.classList.add('visible');
            }
        });
    });
}


const initExpandableAndDropdownToggles = () => {
    const toggleButtons = document.querySelectorAll('[class*="dropdown__toggle"], [class*="expandable__opener"]');

    toggleButtons.forEach(toggle => {
        let sibling = toggle.nextElementSibling;

        // Loop through siblings to find one that has "content" in the class name
        while (sibling) {
            if (sibling.className && sibling.className.includes('content')) {
                ariaExpanded(toggle, sibling); // Apply aria-expanded logic
                break;
            }
            sibling = sibling.nextElementSibling;
        }
    });
};


const enableNavKeyBindings = () => {
    const navLinks = document.querySelectorAll('.nav__link.nav__link--has-children');

    navLinks.forEach(link => {
        const dropdown = link.nextElementSibling;

        if (link) {
            link.setAttribute('tabindex', '0');

            link.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    const isActive = link.classList.contains('nav__link--active');

                    navLinks.forEach(otherLink => {
                        const otherDropdown = otherLink.nextElementSibling;
                        if (otherLink !== link && otherDropdown && otherDropdown.classList.contains('nav__dropdown-wrapper')) {
                            otherLink.classList.remove('nav__link--active');
                            otherDropdown.style.height = '0';
                        }
                    });


                    link.classList.toggle('nav__link--active', !isActive);

                    if (dropdown && dropdown.classList.contains('nav__dropdown-wrapper')) {
                        dropdown.style.height = isActive ? '0' : 'auto';

                        const firstDropdownLink = dropdown.querySelector('.nav__link');
                        if (firstDropdownLink) {
                            firstDropdownLink.focus();
                        }
                    }
                }
            });
        }
    });

    const secondaryLinks = document.querySelectorAll('.nav__links-list--secondary .nav__links-list-item a');

    secondaryLinks.forEach((link, index) => {
        link.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();

                const nextIndex = (e.key === 'ArrowDown')
                    ? (index + 1) % secondaryLinks.length
                    : (index - 1 + secondaryLinks.length) % secondaryLinks.length;

                secondaryLinks[nextIndex].focus();
            }
        });
    });

    document.addEventListener('click', (e) => {
        navLinks.forEach(link => {
            const dropdown = link.nextElementSibling;

            if (dropdown && !link.contains(e.target) && !dropdown.contains(e.target)) {
                link.classList.remove('nav__link--active');
                dropdown.style.height = '0';
            }
        });
    });
}


const initAccessibility = () => {
    // Nav main
    ariaExpanded(document.querySelector('.hamburger'), document.querySelector('.nav'));

    // Nav / sub nav
    const nav = document.querySelector(".nav__menu-inner");
    if(nav){
        applyAriaAttributes(
            '.nav__menu-inner .nav__links-list-item',
            '.nav__dropdown-wrapper',
            false);
    }
    // Accordions
    const accordions = document.querySelectorAll('.accordion__dropdown');

    if(accordions) {
        applyAriaAttributes('.accordion__dropdown', '.accordion__dropdown-content');

        enableTabNavigation(accordions);
    }

    // Agenda tabs
    const tabs = document.querySelector(".tabs__toggle")
    if(tabs) {
        toggleAriaSelected('.tabs__toggle', '.tabs__tab');
    }

    // General
    initExpandableAndDropdownToggles();

    // Enable key bindings for navigation
    enableNavKeyBindings();

}

export default initAccessibility;